<template>
  <div class="messages">
    <div class="messages__header">
      <h3 class="messages__title">Сообщения</h3>
      <span>{{ currentTypeMessages ? "Исходящие" : "Входящие" }}</span>
      <button
        @click="showFilterPanel = true"
        class="messages__run-window-filter"
      >
        <i class="fas fa-filter"></i>
      </button>
    </div>
    <div
      :class="['messages__control', { messagesControlShow: showFilterPanel }]"
    >
      <button
        @click="showFilterPanel = false"
        class="messages__close-window-filter"
      >
        <i class="el-icon-circle-close"></i>
      </button>
      <el-input
        @input="resultGroup.nameStudent.change = !!resultGroup.nameStudent.value"
        v-model="resultGroup.nameStudent.value"
        placeholder="ФИО"
        size="small"
      />
      <el-select
        size="small"
        v-model="resultGroup.typeMessages.value"
        placeholder="Select"
        @change="
          resultGroup.typeMessages.change = !resultGroup.typeMessages.change
        "
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-checkbox
        size="small"
        v-model="resultGroup.checkedReead.value"
        label="Непрочитанные"
        border
        @change="resultGroup.checkedReead.change = !resultGroup.checkedReead.change"
      />
      <el-date-picker
        :size="mobileMode ? 'large' : 'small'"
        v-model="resultGroup.valueFilterDate.value"
        @change="resultGroup.valueFilterDate.change = true"
        type="daterange"
        align="right"
        unlink-panels
        range-separator="До"
        start-placeholder="Начальная дата"
        end-placeholder="Конечная дата"
        :picker-options="pickerOptions"
      >
      </el-date-picker>
      <div class="messages__filter-btn-wrp">
        <el-button
          :disabled="!filterReady"
          @click="runFilter()"
          type="primary"
          size="small"
          >Отфильтровать</el-button
        >
        <el-button @click="clearFilter()" size="small">Очистить</el-button>
      </div>
    </div>
    <div class="messages__list">
      <el-collapse
        accordion
        v-model="activeNames"
        @change="handleChange(message)"
        v-for="(message, index) of tableData"
        :key="message.id"
      >
        <el-collapse-item :name="index">
          <template slot="title">
            <div
              :class="[
                'message-box',
                { messageSelected: selectItems === index },
              ]"
            >
              <div
                :class="[
                  'messages__message-status',
                  { statusActive: message.read == '0' },
                ]"
              ></div>
              <div v-if="message" class="messages__user-avatar">
                <span class="user-avatar__letter">{{
                  initialsFunc(
                    currentTypeMessages
                      ? message.message_recipient.name
                      : message.message_sender.name
                  )
                }}</span>
                <img
                  class="user-avatar__img"
                  :src="
                    'https://teacher.open-college.ru/storage/avatars/' +
                    currentId(message) +
                    '.jpg'
                  "
                  onerror="this.onerror=null;this.style.display = 'none';"
                />
              </div>
              <div class="message-box__name">
                <p>
                  {{
                    currentTypeMessages
                      ? message.message_recipient.name
                      : message.message_sender.name
                  }}
                </p>
                <span v-if="mobileMode">{{
                  dateCorrector(message.datetime)
                }}</span>
              </div>
              <span>{{ message.message_sender.group.name }}</span>
              <el-button
                v-if="!mobileMode"
                class="message-box__show-modal-btn"
                @click.stop="showModalResponse(message)"
                type="text"
                icon="far fa-envelope"
              ></el-button>
              <div class="message-box__date-time">
                <span>{{ dateCorrector(message.datetime) }}</span>
                <span>{{ timeCorrector(message.datetime) }}</span>
              </div>
            </div>
          </template>
          <div class="message-box__body">
            <p v-if="textNormalize(message.text).text" class="message-box__text">{{ textNormalize(message.text).text }}</p>
            <div v-if="textNormalize(message.text).links" class="message-box__links">
              <span v-for="link in textNormalize(message.text).links" :key="link" class="text-is-link">
                <a :href="link">
                  <i class="el-icon-download"/>
                  Скачать
                </a>
              </span>
            </div>

            <el-button
              class="message-box__mobile-modal-run"
              v-if="mobileMode"
              @click.stop="showModalResponse(message)"
              type="text"
              icon="far fa-envelope"
            ></el-button>
          </div>
        </el-collapse-item>
      </el-collapse>
      <div class="messages__notify-box" v-if="!tableData.length">
        <span>Нет сообщений</span>
      </div>
    </div>
    <el-row>
      <el-pagination
        ref="pagination"
        :pager-count="5"
        layout="prev, pager, next"
        @current-change="numberClick"
        :page-size="pagination.stepMessages"
        :total="pagination.quntityMessage"
      >
      </el-pagination>
    </el-row>
  </div>
</template>

<script>
import { mapActions, mapMutations } from "vuex";
export default {
  name: "Messages",
  data() {
    return {
      showFilterPanel: false,
      selectItems: null,
      activeNames: "1",
      pagination: {
        currentPage: 1,
        quntityMessage: 0,
        stepMessages: 20,
        intervalMin: 0,
        intervalMax: 7,
      },
      tableData: [],
      options: [
        {
          value: 0,
          label: "Входящие",
        },
        {
          value: this.$store.state.auth.user.id,
          label: "Исходящие",
        },
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "Неделя",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Месяц",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "3 месяца",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      resultGroup: {
        typeMessages: { value: 0, alias: ["sender"], change: false },
        valueFilterDate: {
          value: "",
          alias: ["start_time", "end_time"],
          change: false,
        },
        checkedReead: { value: false, alias: ["read"], change: false },
        nameStudent: { value: "", alias: ["name"], change: false },
      },
      currentTypeMessages: 0,
    };
  },
  computed: {
    teacherData() {
      return this.$store.state.auth.user;
    },
    linkNextPage() {
      return "/api/messages?page=" + this.pagination.currentPage;
    },
    widthDatePiker() {
      if (this.mobileMode) {
        return window.screen.width + "px";
      }
    },
    filterReady() {
      for (var key in this.resultGroup) {
        if (this.resultGroup[key].change) {
          return true;
        }
      }
      return false;
    },
    mobileMode() {
      return this.$store.state.mobileMode;
    },
  },

  methods: {
    ...mapActions(["fetchMessage", "fetchNextPage", "updateMessage"]),
    ...mapMutations(["setModalData"]),
    selectMessage(value, index) {
      this.selectItems === index
        ? (this.selectItems = null)
        : (this.selectItems = index);
    },

    textNormalize(text) {

      let findElement = text.indexOf("#файлы#");
      let links = null;
      if (findElement !== -1) {
        links = text.match(/(https?:\/\/[^\s]+)/g);
        text = text.substr(0, findElement);
      }
      return { text, links };
    },

    showModalResponse(value) {
      let obj = {
        name: "respMessage",
        data: value,
      };
      this.setModalData(obj);
      this.handleChange(value);
    },
    timeCorrector(value) {
      return this.globalFunctions.timeCorrector(value);
    },
    dateCorrector(value) {
      return this.globalFunctions.dateCorrector(value);
    },
    initialsFunc(val) {
      let arr = val.split(" ");
      let a = arr[0][0];
      let b = arr[1][0] === "(" ? arr[2][0] : arr[1][0];
      return a + b;
    },
    numberClick(value) {
      this.pagination.currentPage = value;
      let path = this.linkNextPage;
      let data = this.objectCreator();
      this.fetchNextPage({ path, data }).then((res) => {
        this.tableData = res.data.messages.data;
      });
    },
    async handleChange(val) {
      if (!val.read) {
        const result = await this.updateMessage(val);

        if (result) {
          this.tableData.forEach(el => {
            if (el.from === val.from) {
              el.read = 1;
            }
          });
        } else {
          this.$notify({ type: 'error', title: 'Ошибка обновления статуса сообщения' });
        }
      }
    },
    currentId(value) {
      return this.currentTypeMessages ? value.to : value.from;
    },
    letterAndCollors() {
      let degVal = 0;
      let deg = 12;
      let lettersObj = {};
      let lettrers = [
        "а",
        "б",
        "в",
        "г",
        "д",
        "е",
        "ё",
        "ж",
        "з",
        "и",
        "й",
        "к",
        "л",
        "м",
        "н",
        "о",
        "п",
        "р",
        "с",
        "т",
        "у",
        "ф",
        "х",
        "ц",
        "ч",
        "ш",
        "щ",
        "э",
        "ю",
        "я",
      ];
      lettrers.forEach((el) => {
        lettersObj[el] = degVal;
        degVal += deg;
      });
      return lettersObj;
    },
    objectCreator() {
      let obj = {};
      for (var key in this.resultGroup) {
        if (this.resultGroup[key].value) {
          if (this.resultGroup[key].alias.length > 1) {
            this.resultGroup[key].alias.forEach((el, index) => {
              obj[el] = this.resultGroup[key].value[index];
            });
          } else {
            let alias = this.resultGroup[key].alias[0];
            obj[alias] =
              typeof this.resultGroup[key].value === "boolean"
                ? Number(this.resultGroup[key].value)
                : this.resultGroup[key].value;
          }
        }
      }
      return obj;
    },
    runFilter() {
      this.fetchMessage(this.objectCreator()).then((res) => {
        this.tableData = res.messages.data;
        this.pagination.quntityMessage = res.messages.total;
        this.clearFields("change");
        this.currentTypeMessages = this.resultGroup.typeMessages.value;
        this.mobileMode ? (this.showFilterPanel = false) : null;
      });
    },
    clearFields(value) {
      for (var key in this.resultGroup) {
        if (value === "full") {
          this.resultGroup[key].change = false;
          if (typeof this.resultGroup[key].value === "number") {
            this.resultGroup[key].value = 0;
          } else if (typeof this.resultGroup[key].value === "string") {
            this.resultGroup[key].value = "";
          } else if (typeof this.resultGroup[key].value === "boolean") {
            this.resultGroup[key].value = false;
          }
        } else if (value === "change") {
          this.resultGroup[key].change = false;
        }
      }
    },
    clearFilter() {
      this.fetchMessage(null).then((res) => {
        this.$refs.pagination.internalCurrentPage = 1;
        this.pagination.currentPage = 1;
        this.tableData = res.messages.data;
        this.pagination.quntityMessage = res.messages.total;
      });
      this.clearFields("full");
    },
  },
  mounted() {
    this.fetchMessage(null).then((res) => {
      this.pagination.quntityMessage = Number(res.messages.total);
      this.pagination.stepMessages = Number(res.messages.per_page);
      let arrayLetters = this.letterAndCollors();
      let response = res.messages.data;
      response.forEach((el) => {
        el.message_sender.color =
          arrayLetters[el.message_sender.name.split(" ")[0][0].toLowerCase()];
      });
      this.tableData = response;
    });
  },
};
</script>

<style lang="scss">
.messages {
  position: relative;
  box-sizing: border-box;
  height: 100%;
  display: grid;
  row-gap: 20px;
  grid-template-rows: max-content max-content auto max-content;
  .messages__header {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    align-items: center;
    h3 {
      align-self: start;
    }
    span {
      align-self: center;
      text-align: center;
    }
  }
  .el-date-editor .el-range-separator {
    margin: 0 10px;
  }
  .messages__run-window-filter {
    display: none;
    i {
      font-size: 30px;
      color: $brand-clr-1;
    }
  }
  .messages__close-window-filter {
    display: none;
    position: absolute;
    right: 20px;
    top: 70px;
    i {
      font-size: 35px;
      color: $brand-clr-1;
    }
  }
  .message-box__show-modal-btn {
    i {
      font-size: 25px;
    }
  }

  .message-box__links {
    display: flex;
    column-gap: 10px;
  }
  .messages__control {
    display: grid;
    grid-auto-flow: column;
    column-gap: 10px;
  }
  .messages__list {
    overflow-y: scroll;
    height: 100%;
  }
  .el-collapse-item__header {
    height: 65px;
  }
  .message-box {
    display: grid;
    width: 100%;
    justify-items: center;
    grid-template-columns: 30px 60px 1fr 1fr 1fr 1fr;
    align-items: center;
  }
  .messages__notify-box {
    display: flex;
    justify-content: center;
    align-content: center;
    height: 100%;
    span {
      display: flex;
      align-items: center;
    }
  }
  .el-collapse-item__header {
    &:hover {
      background-color: $lighter-border-clr;
    }
  }
  .messages__message-status {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: transparent;
    margin: 0 auto;
  }
  .statusActive {
    background-color: $brand-clr-1;
  }
  .messages__user-avatar {
    position: relative;
    margin: 0;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: $placeholder-text-clr;
  }

  .user-avatar__letter {
    z-index: 2;
    font-weight: bold;
    position: absolute;
  }
  .message-box__name {
    text-align: left;
    line-height: 20px;
    align-self: center;
    justify-self: flex-start;
    P {
      margin: 0;
    }
  }

  .text-is-link {
    background-color: $brand-clr-1;
    gap: 5px;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: max-content;
    padding: 5px 10px;
    border-radius: 10px;
    i {
      font-size: 20px;
      color: $basic-white;
    }
    a {
      display: flex;
      align-items: center;
      color: $basic-white;
    }
  }

  .message-box__date-time {
    display: flex;
    flex-wrap: wrap;
    align-self: center;
    span {
      text-align: center;
      width: 100%;
      line-height: 20px;
    }
  }
  .message-box__mobile-modal-run {
    i {
      font-size: 25px;
      margin: 0 10px;
    }
  }
  .message-box__body {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin: 10px;
  }
  .el-collapse {
    display: flex;
    align-items: center;
  }
  .el-checkbox {
    padding-right: 10px;
  }
  .el-collapse-item {
    width: 100%;
  }
  .el-collapse-item__content {
    p {
      margin: 0;
    }
  }
}
.user-avatar__img {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 5;
}
.el-pagination {
  text-align: center;
}
@media (max-width: 800px) {
  .el-picker-panel__body {
    min-width: 100% !important;
    .is-left {
      width: 100%;
    }
    .is-right {
      display: none !important;
    }
  }
  .el-picker-panel {
    overflow-y: hidden !important;
    width: 100% !important;
    .el-picker-panel__body-wrapper {
      .el-picker-panel__sidebar {
        padding: 15px 0;
        display: flex;
        justify-content: space-around;
        width: 100% !important;
        position: relative !important;
        .el-picker-panel__shortcut {
          text-align: center;
          font-size: 18px;
          border: 1px solid $secondary-text-clr;
          border-radius: 10px;
          padding-left: 0;
          width: 30%;
          &:active {
            background-color: $brand-clr-1;
            color: $basic-white;
          }
        }
      }
      .el-picker-panel__body {
        margin-left: 0;
      }
    }
  }
  .messages {
    grid-template-rows: max-content auto max-content;
    .messages__header {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .messages__run-window-filter {
      display: inline-block;
    }
    .messages__close-window-filter {
      display: inline-block;
    }
    .messages__control {
      position: fixed;
      padding: 150px 30px 30px 30px;
      right: 0;
      top: 0;
      height: 100%;
      width: 100%;
      background-color: $basic-white;
      display: grid;
      grid-template-rows: repeat(4, max-content);
      row-gap: 20px;
      z-index: 10;
      margin: auto 0;
      transition-duration: 0.5s;
      transition-property: transform opacity;
      transform: translateX(-105%);
      opacity: 0;
      align-items: center;
      .el-select {
        display: block;
        margin-bottom: 20px;
        height: 40px;
        .el-input__inner {
          height: 40px;
          font-size: 20px;
        }
      }
      .el-checkbox {
        border: none;
        display: block;
        margin-left: 0 !important;
        margin-right: 0;
        margin-bottom: 20px;
        .el-checkbox__inner {
          width: 20px !important;
          height: 20px !important;
        }
        .el-checkbox__label {
          font-size: 20px !important;
        }
      }
      .el-date-editor {
        width: 100%;
        margin-bottom: 20px;
      }
      .messages__filter-btn-wrp {
        margin: 0 auto;
        display: flex;
        justify-content: center;
      }
    }
    .messages__list {
      overflow-y: scroll;
      height: 100%;
    }
    .message-box {
      display: grid;
      width: 100%;
      justify-items: center;
      grid-template-columns: 15px 60px auto;
      align-items: center;
    }
    .message-box__body {
      display: grid;
      grid-template-columns: 1fr;
      grid-template-rows: 1fr max-content;
    }
    .message-box__mobile-modal-run {
      i {
        font-size: 40px;
      }
    }
    .message-box__date-time {
      display: none;
    }
    .el-tooltip {
      display: none;
    }
    .messagesControlShow {
      transform: translateX(0);
      opacity: 1;
    }
  }
}
</style>
